export default {
    sortProperties: function sortProperties(items, locale, attribute, descending) {
        // 'kn' will use numeric collation ('1' < '2' < '10')
        var locales = locale.replace('_', '-') + '-u-kn-true';
        return items.slice().sort(function (x, y) {
            var xValue = x && x[attribute] ? x[attribute] : '';
            var yValue = y && y[attribute] ? y[attribute] : '';
            var comparisonResult = xValue.localeCompare(yValue, locales);
            return descending ? -comparisonResult : comparisonResult;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-js/LocaleUtil.js
// module id = 1376
// module chunks = 0